import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import paths from "routes/paths";

// Signed in and not signed out since. Whether the token is still good is the
// server's to say on the next request: an expired access token is renewed there,
// and a session the server refuses signs the user out, which lands here.
const hasSession = ({ isAuthenticated, token }) =>
  Boolean(isAuthenticated && token);

export const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const auth = useSelector((state) => state.auth);
  const { user } = auth;
  const location = useLocation();

  if (!hasSession(auth)) {
    return <Navigate to={paths.cardLogin} state={{ from: location }} replace />;
  }

  if (requiredRoles.length > 0 && user) {
    const userHasRequiredRole = user.roles.some((role) =>
      requiredRoles.includes(role.name)
    );
    if (!userHasRequiredRole) {
      return <Navigate to={paths.error401} replace />;
    }
  }

  return children;
};
